import { cn } from "@devhop/ui";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { POSMobileMenuSheet } from "./POSMobileMenuSheet";
import {
  isPOSMoreMenuActive,
  POS_MORE_MENU_ICON,
  POS_PRIMARY_NAV,
} from "./pos-nav-config";

type POSBottomBarProps = {
  className?: string;
};

export function POSBottomBar({ className }: POSBottomBarProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const MoreIcon = POS_MORE_MENU_ICON;
  const moreActive = isPOSMoreMenuActive(pathname) || menuOpen;

  return (
    <>
      <nav
        aria-label="POS navigation"
        className={cn(
          "pos-bottom-bar z-50 flex shrink-0 items-stretch justify-around border-t bg-card/95 px-1 backdrop-blur supports-backdrop-filter:bg-card/80 lg:hidden",
          className,
        )}
      >
        {POS_PRIMARY_NAV.map((item) => {
          const active = item.isActive(pathname);
          const Icon = item.icon;

          return (
            <button
              key={item.key}
              type="button"
              onClick={() => navigate(item.navigate())}
              className={cn(
                "relative flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-1 py-2 font-medium text-[10px] transition-colors",
                active ? "text-primary" : "text-muted-foreground",
              )}
            >
              {active ? (
                <span className="absolute inset-x-3 top-0 h-0.5 rounded-full bg-primary" />
              ) : null}
              <span
                className={cn(
                  "flex h-9 w-11 items-center justify-center rounded-2xl transition-colors",
                  active && "bg-primary/12",
                )}
              >
                <Icon className="h-5 w-5" strokeWidth={active ? 2.25 : 2} />
              </span>
              <span className="max-w-full truncate">{item.mobileLabel}</span>
            </button>
          );
        })}

        <button
          type="button"
          onClick={() => setMenuOpen(true)}
          className={cn(
            "relative flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-1 py-2 font-medium text-[10px] transition-colors",
            moreActive ? "text-primary" : "text-muted-foreground",
          )}
        >
          {moreActive ? (
            <span className="absolute inset-x-3 top-0 h-0.5 rounded-full bg-primary" />
          ) : null}
          <span
            className={cn(
              "flex h-9 w-11 items-center justify-center rounded-2xl transition-colors",
              moreActive && "bg-primary/12",
            )}
          >
            <MoreIcon className="h-5 w-5" strokeWidth={moreActive ? 2.25 : 2} />
          </span>
          <span className="max-w-full truncate">ເພີ່ມ</span>
        </button>
      </nav>

      <POSMobileMenuSheet open={menuOpen} onOpenChange={setMenuOpen} />
    </>
  );
}
